import script from "./MediaConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./MediaConfirmation.vue?vue&type=style&index=0&id=617a7ff8&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-617a7ff8"]])

export default __exports__